import { QuoteLineItem } from "./quote";
import { LineItem } from "./line-item";

// Mapping functions to convert between form model and API model
export function toApiModel(model: LineItem): QuoteLineItem {
  return {
    jrpid: model.id,
    jrptrackingid: model.trackingId,
    jrptype: model.type,
    jrplabel: model.title,
    jrpdetail: model.type === "GroupStart" 
      ? model.groupName 
      : model.description,
    jrpunits: model.quantity,
    jrpunittype: model.unit,
    jrpunitcost: model.unitCost,
    jrpunitmarkup: model.markup,
    jrpunittax: model.applyTax ? 1 : 0,
    jrpexcaddmarkup: model.excludeAdditionalMarkup ? 1 : 0,
    jrpcost: model.cost,
    jrppub: null,
    jrppubcost: null,
    jrpdisp: null,
    jrpusequotefile: model.useQuoteFile ? 1 : 0,
    jrpuseclaimfile: model.useClaimFile ? 1 : 0,
    jrpusewofile: model.useWorkOrderFile ? 1 : 0,
    jrpdate: model.date,
    jrpaccept: model.accepted ? "Yes" : null,
    jrpinitials: model.initials,
    jrpreason: model.reason,
    jrpreasonnotes: model.reasonNotes,
    jrpsuppid: model.typeId,
    mid: model.materialTypeId,
    miid: model.materialStyleId,
    mpid: model.materialSupplierId,
    lcid: model.laborCategoryId,
    ltid: model.laborTypeId,
    jrporder: model.order,
    mstyle: model.materialStyle,
    jrpsectionid: model.sectionId,
    jrpfilename_s3: model.filenameS3,
    jrpfilename: model.filename,
    jrpmfid: model.appliedFormulaId,
    jrpparenttexttrackingid: model.parentTextTrackingId
  };
}

export function fromApiModel(apiModel: QuoteLineItem): LineItem {
  return {
    id: apiModel.jrpid,
    trackingId: apiModel.jrptrackingid || crypto.randomUUID(),
    type: apiModel.jrptype,
    title: apiModel.jrplabel,
    description: apiModel.jrptype === "GroupStart" ? null : apiModel.jrpdetail,
    quantity: apiModel.jrpunits ?? null,
    unit: apiModel.jrpunittype,
    unitCost: apiModel.jrpunitcost ?? null,
    cost: apiModel.jrpcost ?? null,
    markup: apiModel.jrpunitmarkup ?? null,
    applyTax: !!apiModel.jrpunittax,
    excludeAdditionalMarkup: !!apiModel.jrpexcaddmarkup,
    materialTypeId: apiModel.mid ?? null,
    materialStyleId: apiModel.miid ?? null,
    materialSupplierId: apiModel.mpid ?? null,
    typeId: apiModel.jrpsuppid,
    useQuoteFile: !!apiModel.jrpusequotefile,
    useClaimFile: !!apiModel.jrpuseclaimfile,
    useWorkOrderFile: !!apiModel.jrpusewofile,
    date: apiModel.jrpdate,
    accepted: apiModel.jrpaccept === "Yes",
    initials: apiModel.jrpinitials,
    reason: apiModel.jrpreason,
    reasonNotes: apiModel.jrpreasonnotes,
    order: apiModel.jrporder ?? null,
    materialStyle: apiModel.mstyle ?? null,
    groupName: apiModel.jrptype === "GroupStart" ? apiModel.jrpdetail : null,
    sectionId: apiModel.jrpsectionid,
    filenameS3: apiModel.jrpfilename_s3,
    filename: apiModel.jrpfilename,
    appliedFormulaId: apiModel.jrpmfid,
    parentTextTrackingId: apiModel.jrpparenttexttrackingid,
    laborCategoryId: apiModel.lcid ?? null,
    laborTypeId: apiModel.ltid ?? null
  };
} 